import { colourString } from '@keplerco/core';

export const DESKTOP_FONT_SIZE = 15;
export const MOBILE_FONT_SIZE = 12;
export const FONT_COLOUR = colourString('text');
